import { useSelector } from 'react-redux';
import { selectJwt } from '../../ui-frame/state/ui-frame.slice';
import useCommonDeviceDataService from '../../patch-view/services/common-device-data-service/useCommonDeviceDataService';
import useSwr from 'swr';
import { Device, Group } from 'synapse-common-device-service';
import useGetGlobalSelectedTenants from './useGetGlobalSelectedTenants';

export type TenantDevicesAndGroups = {
  tenantDevices: Device[];
  deviceGroups: Group[];
};

export default function useGetTenantDevicesAndGroups(): TenantDevicesAndGroups {
  const { commonDeviceDataService, isCommonDeviceDataServiceReady } = useCommonDeviceDataService();
  const jwtToken = useSelector(selectJwt);

  commonDeviceDataService.setToken(jwtToken);

  const globalTenants = useGetGlobalSelectedTenants();

  const tenantIds = globalTenants
    .filter(tenant => tenant.uuid !== 'items-without-tenant')
    .map(tenant => {
      return tenant?.uuid;
    });

  const { data: groupsData } = useSwr(
    isCommonDeviceDataServiceReady ? ['getDeviceGroups'] : null,
    () => commonDeviceDataService.getDeviceGroups(),
    {
      shouldRetryOnError: false
    }
  );

  const { data: tenantDevicesData } = useSwr(
    isCommonDeviceDataServiceReady ? ['getDevices', tenantIds] : null,
    () => commonDeviceDataService.getDevices(tenantIds.length > 0 ? { tenantIds } : {}),
    {
      shouldRetryOnError: false
    }
  );

  return {
    tenantDevices: tenantDevicesData ?? [],
    deviceGroups: groupsData ?? []
  };
}
